import { InputNumber, Modal, Space, Typography } from 'antd'
import { observer } from 'mobx-react-lite'

import { useNotification } from '@/Core/Hooks/useNotification'

import type { TaskCrudContextLike } from '../../Contracts/Crud.types'
import type { CompleteTaskModalStore } from '../../Stores/CompleteTaskModalStore'

const { Text } = Typography

interface Props {
    store: CompleteTaskModalStore
    crudContext?: TaskCrudContextLike
}

/**
 * Модалка завершення задачі (SPEC-008 §8.2, перенос легасі `CompleteTaskModal.jsx`).
 * Години (0+) та хвилини (0–59) → `store.totalMinutes`; підтвердження шле
 * `CompleteTaskTask` і перезавантажує картку. Стан — у MobX-сторі (`observer`).
 */
export const CompleteTaskModal = observer(({ store, crudContext }: Props) => {
    const { showSuccess, showError } = useNotification()

    const handleOk = (): void => {
        void store.confirm({ success: showSuccess, error: showError }, () => crudContext?.actions?.reloadData?.())
    }

    return (
        <Modal
            title="Завершити завдання"
            open={store.open}
            onOk={handleOk}
            onCancel={() => store.close()}
            confirmLoading={store.loading}
            okText="Завершити"
            cancelText="Скасувати"
        >
            <div style={{ marginTop: 16 }}>
                <Text>Витрачений час:</Text>
                <div style={{ marginTop: 8 }}>
                    <Space>
                        <InputNumber
                            min={0}
                            value={store.hours}
                            onChange={(v) => store.setHours(Number(v ?? 0))}
                            addonAfter="год"
                        />
                        <InputNumber
                            min={0}
                            max={59}
                            value={store.minutes}
                            onChange={(v) => store.setMinutes(Number(v ?? 0))}
                            addonAfter="хв"
                        />
                    </Space>
                </div>
                {store.error && (
                    <Text type="danger" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
                        Вкажіть витрачений час (більше 0)
                    </Text>
                )}
            </div>
        </Modal>
    )
})
